const SPECIAL_REGEX = /[@~`!#$%^&*+=\-[\]\\';,/{}|\\":<>?]/
const UPPERCASE_REGEX = /[A-Z]/
const LOWERCASE_REGEX = /[a-z]/
const NUMERIC_REGEX = /\d/

export const getDefaultConfig = () => {
  return {
    minChar: 10,
    minUniqueChar: 4,
    reqMixedCase: false,
    reqSpecialChar: true,
    reqNumber: false,
  }
}

export const hasMinCharacters = (password, config) => {
  return password.length >= config.minChar
}

export const hasMinUniqueCharacters = (password, config) => {
  return new Set(password).size >= config.minUniqueChar
}

export const hasSpecialCharacter = (password, config) => {
  if (config.reqSpecialChar) {
    return SPECIAL_REGEX.test(password)
  }
  return true
}

export const hasMixedCase = (password, config) => {
  if (config.reqMixedCase) {
    return UPPERCASE_REGEX.test(password) && LOWERCASE_REGEX.test(password)
  }
  return true
}

export const hasNumber = (password, config) => {
  if (config.reqNumber) {
    return NUMERIC_REGEX.test(password)
  }
  return true
}

export const meetsAllRequirements = (password, config) => {
  return (
    hasMinCharacters(password, config) &&
    hasSpecialCharacter(password, config) &&
    hasMinUniqueCharacters(password, config) &&
    hasMixedCase(password, config) &&
    hasNumber(password, config)
  )
}
